import { IBaseService } from "@pit/core";
import { IDtoUser } from "@pit/frontend-model";
import { IAuthenticationDataService } from "../../services/interfaces/authentication.data.service.interface";
import { IDtoAppVersionEntityDataService } from "../../services/interfaces/dto.app.version.entity.data.service.interface";
import { IDtoDepotEntityDataService } from "../../services/interfaces/dto.depot.entity.data.service.interface";
import { IDtoDeviceEntityDataService } from "../../services/interfaces/dto.device.entity.data.service.interface";
import { IDtoSettingEntityDataService } from "../../services/interfaces/dto.setting.entty.data.service.interface";
import { IDtoShipmentEntityDataService } from "../../services/interfaces/dto.shipment.entity.data.service.interface";
import { IDtoUserEntityDataService } from "../../services/interfaces/dto.user.entity.data.service.interface";
import { IDtoUserRoleEntityDataService } from "../../services/interfaces/dto.user.role.entity.data.service.interface";
import { ICommunicationDataService } from "../../services/interfaces/communication.data.service.interface";
import { ICronDataService } from "../../services/interfaces/cron.data.service.interface";
import { IDtoArchiveEntityDataService } from "../../services/interfaces/dto.archive.entity.data.service.interface";
import { IDtoShipmentProcessEntityDataService } from "../../services/interfaces/dto.shipment.process.entity.data.service.interface";
import { IDtoShipmentReturnCodeEntityDataService } from "../../services/interfaces/dto.shipment.return.code.entity.data.service.interface";
import { IDtoLocationEntityDataService } from "../../services/interfaces/dto.location.entity.data.service.interface";
import { IDtoResourceEntityDataService } from "../../services/interfaces/dto.resource.entity.data.service.interface";
import { IDtoResourceCheckEntityDataService } from "../../services/interfaces/dto.resource.check.entity.data.service.interface";
import { IDtoResourceUserEntityDataService } from "../../services/interfaces/dto.resource.user.entity.data.service.interface";
import { IDtoResourceTypeEntityDataService } from "../../services/interfaces/dto.resource.type.entity.data.service.interface";
import { IDtoResourceFaultEntityDataService } from "../../services/interfaces/dto.resource.fault.entity.data.service.interface";

export interface IPinItTrackFrontentDataServicesAccessor extends IBaseService {

    currentUser: IDtoUser;

    appVersionDataService: IDtoAppVersionEntityDataService;
    archiveDataService: IDtoArchiveEntityDataService;
    authenticationDataService: IAuthenticationDataService;
    communicationDataService: ICommunicationDataService;
    cronDataService: ICronDataService;
    depotDataService: IDtoDepotEntityDataService;
    deviceDataService: IDtoDeviceEntityDataService;
    locationDataService: IDtoLocationEntityDataService;
    settingDataService: IDtoSettingEntityDataService;
    shipmentDataService: IDtoShipmentEntityDataService;
    shipmentProcessDataService: IDtoShipmentProcessEntityDataService;
    shipmentReturnCodeDataService: IDtoShipmentReturnCodeEntityDataService;
    userDataService: IDtoUserEntityDataService;
    userRoleDataService: IDtoUserRoleEntityDataService;
    resourceDataService: IDtoResourceEntityDataService;
    resourceCheckService: IDtoResourceCheckEntityDataService;
    resourceUserDataService: IDtoResourceUserEntityDataService;
    resourceTypeDataService: IDtoResourceTypeEntityDataService;
    resourceFaultDataService: IDtoResourceFaultEntityDataService;

}
